import { isRef } from "vue";
import useGoogleTag from "@/composables/useGoogleTag";

const useUtilities = () => {
  const toggle = (target) =>
    isRef(target) ? (target.value = !target.value) : (target = !target);

  const getFileType = (file) => {
    return file.type?.split("/")[0];
  };

  const getMimeType = (file) => {
    return file.type?.split("/")[1];
  };
  const getFileExtension = (file) => {
    return file.name?.substring(
      file.name?.lastIndexOf(".") + 1,
      file.name?.length
    );
  };
  const makeFileObject = async (url, fileName = "test") => {
    let response = await fetch(url);
    let data = await response.blob();
    let metadata = {
      type: "image/gif",
    };
    return new File([data], fileName, metadata);
  };

  const copyToClipboard = (data) => {
    const { registerEvent } = useGoogleTag();
    navigator.clipboard.writeText(data);
    registerEvent("nft link copied to clipboard");
  };

  return {
    toggle,
    getFileType,
    getMimeType,
    makeFileObject,
    copyToClipboard,
    getFileExtension,
  };
};

export default useUtilities;
